import React from 'react';
import { Maximize, Building2, ArrowLeftRight, DollarSign } from 'lucide-react';
export function AssetOverview() {
  return <section className="w-full bg-[#87C4D8]" data-id="element-1">
      {/* Drone aerial image - full width, prominent */}

      {/* Metrics */}
      <div className="py-20 px-6" data-id="element-2">
        <div className="max-w-7xl mx-auto" data-id="element-3">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-16 tracking-tight" data-id="element-4">
            Asset Overview
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 md:gap-8" data-id="element-5">
            {/* Metric 1: Land Area */}
            <div className="flex flex-col items-start p-6 border-l-2 border-[#1A1A1A] md:border-l-0 md:border-r md:border-[#1A1A1A]/10 pl-6 md:pl-0" data-id="element-6">
              <Maximize className="w-8 h-8 text-[#1A1A1A] mb-4 stroke-1" data-id="element-7" />
              <h3 className="text-[#1A1A1A]/60 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-8">
                Land Area
              </h3>
              <p className="text-[#1A1A1A] text-4xl font-light tracking-tight" data-id="element-9">
                187 sqm*
              </p>
            </div>

            {/* Metric 2: Building Area */}
            <div className="flex flex-col items-start p-6 border-l-2 border-[#1A1A1A] md:border-l-0 md:border-r md:border-[#1A1A1A]/10 pl-6 md:pl-0" data-id="element-10">
              <Building2 className="w-8 h-8 text-[#1A1A1A] mb-4 stroke-1" data-id="element-11" />
              <h3 className="text-[#1A1A1A]/60 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-12">
                Building Area
              </h3>
              <p className="text-[#1A1A1A] text-4xl font-light tracking-tight" data-id="element-13">
                292 sqm*
              </p>
            </div>

            {/* Metric 3: Combined Frontage */}
            <div className="flex flex-col items-start p-6 border-l-2 border-[#1A1A1A] md:border-l-0 md:border-r md:border-[#1A1A1A]/10 pl-6 md:pl-0" data-id="element-14">
              <ArrowLeftRight className="w-8 h-8 text-[#1A1A1A] mb-4 stroke-1" data-id="element-15" />
              <h3 className="text-[#1A1A1A]/60 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-16">
                Combined Frontage
              </h3>
              <p className="text-[#1A1A1A] text-4xl font-light tracking-tight" data-id="element-17">
                44 m*
              </p>
            </div>

            {/* Metric 4: Annual Income */}
            <div className="flex flex-col items-start p-6 border-l-2 border-[#1A1A1A] md:border-l-0 pl-6 md:pl-0" data-id="element-18">
              <DollarSign className="w-8 h-8 text-[#1A1A1A] mb-4 stroke-1" data-id="element-19" />
              <h3 className="text-[#1A1A1A]/60 text-sm font-bold uppercase tracking-wider mb-2" data-id="element-20">
                Annual Income
              </h3>
              <p className="text-[#1A1A1A] text-4xl font-light tracking-tight" data-id="element-21">
                $160,335*
              </p>
              <p className="text-[#1A1A1A]/60 text-xs mt-1 font-medium uppercase tracking-wide" data-id="element-22">
                + GST + Outgoings
              </p>
            </div>
          </div>

          <div className="mt-16 pt-6 border-t border-[#1A1A1A]/10 flex justify-between items-center" data-id="element-23">
            <p className="text-[#1A1A1A]/60 text-sm italic" data-id="element-24">
              *Approximately. Outline Indicative Only.
            </p>
          </div>
        </div>
      </div>
    </section>;
}